module.exports = __webpack_public_path__ + "static/media/bg3.5729b2af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/backgrounds/bg3.jpg
// module id = 1087
// module chunks = 0